import { render, staticRenderFns } from "./MiniProductsTable.vue?vue&type=template&id=5ee0cc81&scoped=true&"
import script from "./MiniProductsTable.vue?vue&type=script&lang=js&"
export * from "./MiniProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniProductsTable.vue?vue&type=style&index=0&id=5ee0cc81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee0cc81",
  null
  
)

export default component.exports